(function () {
  'use strict';

  function autoplayVideoInSlide(slide) {
    if (!slide) return;

    // Native HTML5 video (controls removed and muted via Liquid)
    var nativeMedia = slide.querySelector('.product-single__media-native-video');
    if (nativeMedia) {
      var video = nativeMedia.querySelector('video');
      if (video && video.paused) {
        video.play().catch(function () {});
      }
    }

    // External video (YouTube / Vimeo) — overlay hidden via CSS, start via postMessage
    var externalMedia = slide.querySelector('.product-single__media-external-video');
    if (externalMedia) {
      var iframe = externalMedia.querySelector('iframe');
      if (iframe) {
        try {
          var provider = externalMedia.dataset.provider;
          if (provider === 'youtube') {
            iframe.contentWindow.postMessage(JSON.stringify({
              event: 'command',
              func: 'playVideo',
              args: ''
            }), '*');
          } else if (provider === 'vimeo') {
            iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
          }
        } catch (e) {}
      }
    }
  }

  function initVideoAutoplay() {
    var productSlider = document.querySelector('product-slider');
    if (!productSlider || typeof Flickity === 'undefined') return;

    var flkty = Flickity.data(productSlider);
    if (!flkty) {
      setTimeout(initVideoAutoplay, 200);
      return;
    }

    // Autoplay when a slide settles into view
    flkty.on('settle', function (index) {
      if (flkty.cells[index]) {
        autoplayVideoInSlide(flkty.cells[index].element);
      }
    });

    // Autoplay if the initial active slide is already a video
    if (flkty.selectedIndex !== undefined && flkty.cells[flkty.selectedIndex]) {
      autoplayVideoInSlide(flkty.cells[flkty.selectedIndex].element);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initVideoAutoplay, 100);
    });
  } else {
    setTimeout(initVideoAutoplay, 100);
  }
})();
